import { TextareaAutosize } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";

const RHFTextareaMaterial = (props) => {
  const { name, id, isControlled, control, errorObj } = props;
  let isError = false;
  let errorMessage = "";

  if (errorObj && Object?.keys(errorObj)?.includes(name)) {
    console.log(errorObj);
    isError = true;
    errorMessage = errorObj[name]?.message;
  }

  if (isControlled) {
    return (
      <div className="flex flex-1 flex-col">
        <Controller
          name={name}
          control={control}
          render={({ field }) => {
            return (
              <>
                <TextareaAutosize {...props} {...field} />
                {isError ? (
                  <p className="text-[10px] pt-[2px] text-[red]">
                    {errorMessage}
                  </p>
                ) : (
                  ""
                )}
              </>
            );
          }}
        />
      </div>
    );
  }

  return (
    <div>
      <TextareaAutosize {...props} />
    </div>
  );
};

export default RHFTextareaMaterial;
